import fetch from '../auth/FetchInterceptor';
import useSWR from 'swr';

export default function useDocsNavPages() {
  const { data, error, isLoading } = useSWR(`/documentation/nav`, fetch, {
    refreshInterval: 0,
  });

  return {
    pages: data?.data,
    isLoading,
    isError: error,
  };
}
